"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactSvg = require("react-svg");
var _MyAccountUserDetails = _interopRequireDefault(require("./MyAccountUserDetails"));
var _Button = _interopRequireDefault(require("../../Atoms/Button"));
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
require("./myAccountDropdown.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || (0, _typeof2.default)(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var MyAccountItemList = _react.default.lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./MyAccountItemList'));
  });
});
var keys = {
  MyAccountContainer: 'my-account-dropdown'
};
var getDefaultSoldTo = function getDefaultSoldTo(soldToList) {
  if (soldToList === null || soldToList === undefined || soldToList.length <= 0) return {};
  var defaultSoldTo = soldToList.filter(function (item) {
    return item.soldToFlag === 1;
  })[0];
  return defaultSoldTo || {};
};
var MyAccountContainer = function MyAccountContainer(props) {
  var _props$myAccountConfi = props.myAccountConfig,
    createAccount = _props$myAccountConfi.createAccount,
    userIcon = _props$myAccountConfi.userIcon,
    itemList = _props$myAccountConfi.itemList,
    notRegistered = _props$myAccountConfi.notRegistered,
    signIn = _props$myAccountConfi.signIn,
    signOut = _props$myAccountConfi.signOut,
    switchAccount = _props$myAccountConfi.switchAccount,
    loginState = _props$myAccountConfi.loginState,
    userDetails = _props$myAccountConfi.userDetails,
    closeIcon = _props$myAccountConfi.closeIcon,
    signOutRequest = _props$myAccountConfi.signOutRequest,
    myAccount = _props$myAccountConfi.myAccount,
    signInRedirectKey = _props$myAccountConfi.signInRedirectKey,
    logoDirectoryPath = _props$myAccountConfi.logoDirectoryPath,
    logoDataLocator = _props$myAccountConfi.logoDataLocator,
    renderCompanyLogo = _props$myAccountConfi.renderCompanyLogo,
    ePRocMyAccount = _props$myAccountConfi.ePRocMyAccount,
    closeOverlay = props.closeOverlay,
    userLabel = props.userLabel;
  var firstName = userDetails.firstName,
    lastName = userDetails.lastName,
    soldTo = userDetails.soldTo,
    _userDetails$company = userDetails.company,
    company = _userDetails$company === void 0 ? '' : _userDetails$company;
  var userName = firstName && lastName ? userLabel : '';
  var priorityAccount = getDefaultSoldTo(soldTo);
  var name = priorityAccount.name,
    displayCustomerNumber = priorityAccount.displayCustomerNumber;
  var accountName = name ? name + " " : company;
  accountName = displayCustomerNumber ? accountName + " " + displayCustomerNumber : accountName;
  var key = signInRedirectKey || 'waters.signInRedirect';
  var onSignIn = function onSignIn(e) {
    e.preventDefault();
    window.sessionStorage.setItem(key, window.location.href);
    window.location.href = signIn.url;
  };
  var onSignOut = function onSignOut(e) {
    e.preventDefault();
    signOutRequest({
      signOutUrl: signOut.url
    });
  };
  var signInOutLink = function signInOutLink() {
    return signOut.url && signIn.url && _react.default.createElement(_Anchor.default, (0, _extends2.default)({
      className: "my-account-dropdown__sign-in-out",
      elementLocator: loginState === true ? 'header-my-account-sign-out' : 'header-my-account-sign-in',
      href: loginState === true ? signOut.url : signIn.url
    }, !loginState && {
      onClick: function onClick(e) {
        return onSignIn(e);
      },
      rel: 'nofollow'
    }, loginState && {
      onClick: function onClick(e) {
        return onSignOut(e);
      }
    }), userIcon && _react.default.createElement(_reactSvg.ReactSVG, {
      wrapper: "span",
      src: userIcon,
      className: "sign-in-out__icon",
      "data-locator": "header-login-status-user-icon"
    }), loginState ? signOut.text : signIn.text);
  };
  var headerTitle = function headerTitle(title) {
    return _react.default.createElement("div", {
      className: "header-with-title-wrap"
    }, _react.default.createElement("div", {
      className: "cmp-modal__header header-with-title "
    }, _react.default.createElement("div", {
      className: "cmp-modal__title"
    }, _react.default.createElement("div", {
      className: "cmp-modal__title-text",
      "data-locator": "header-account-title-mobile-view"
    }, title)), _react.default.createElement("div", {
      className: "cmp-modal__close-icon",
      onClick: function onClick() {
        return closeOverlay("myAccount");
      }
    }, closeIcon && _react.default.createElement(_reactSvg.ReactSVG, {
      wrapper: "span",
      src: closeIcon,
      className: "cmp-modal__close",
      "data-locator": "header-account-mobile-view-close-icon"
    }))));
  };
  var createAccountButton = function createAccountButton() {
    return notRegistered && createAccount.url && createAccount.text && _react.default.createElement("div", {
      className: "my-account-dropdown__create-account"
    }, notRegistered, _react.default.createElement(_Anchor.default, (0, _extends2.default)({
      className: "cmp-button",
      to: createAccount.url,
      elementLocator: "link-header-create-account"
    }, {
      onClick: function onClick() {
        window.sessionStorage.setItem(key, window.location.href);
      }
    }), _react.default.createElement(_Button.default, {
      className: "primary",
      elementLocator: "button-header-create-account-text"
    }, createAccount.text)));
  };
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: "top-bar__nav__user__dropdown " + (ePRocMyAccount === true ? 'eproc-my-account' : ''),
    "data-locator": "my-account-user-dropdown-container"
  }, headerTitle(myAccount.text), _react.default.createElement("div", {
    className: keys.MyAccountContainer
  }, loginState && _react.default.createElement(_MyAccountUserDetails.default, {
    userName: userName,
    accountName: accountName,
    switchAccount: switchAccount,
    userDetails: userDetails,
    company: company,
    logoDirectoryPath: logoDirectoryPath,
    logoDataLocator: logoDataLocator,
    renderCompanyLogo: renderCompanyLogo,
    ePRocMyAccount: ePRocMyAccount
  }), itemList && _react.default.createElement(_react.Suspense, {
    fallback: _react.default.createElement("div", null)
  }, _react.default.createElement(MyAccountItemList, {
    itemList: itemList,
    userDetails: userDetails,
    ePRocMyAccount: ePRocMyAccount
  })), signOut && signInOutLink(), !loginState && createAccountButton())));
};
MyAccountContainer.defaultProps = {
  myAccountConfig: {},
  closeOverlay: function closeOverlay() {
    /* default closeOverlay handler */
  },
  userLabel: ''
};
var _default = MyAccountContainer;
exports.default = _default;
module.exports = exports["default"];